module.exports = "/_next/static/images/dd18708aeb49087c41dfb637b88fef40-roxinho-card-with-phone-xs@2x.png";